<label class="checkbox-inline" *ngIf="items && items.length > 1 && wildcardOptionLabel != null">
	<input [name]="id + '_tous'" [id]="id + '_tous'"
		type="checkbox"
		[(ngModel)]="optionAllChecked"
		(ngModelChange)="onOptionAllChange()"
		/>
	<i>{{ wildcardOptionLabel }}</i>
</label>
<label *ngFor="let item of items; let index = index"
	class="checkbox-inline"
	[attr.title]="titleGetter(item)"
	[style.color]="labelColorGetter(item)"
	>
      	<input [name]="id + '_' + index" [id]="id + '_' + index"
	      	type="checkbox" 
			[(ngModel)]="optionsChecked[index]"
			(ngModelChange)="onOptionChange(index)"
			/>
		{{ labelGetter(item) }}
</label>